import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import statementService from "./statementService";

interface StatementState {
  isLoading: boolean;
  isSuccessful: boolean;
}

const initialState: StatementState = {
  isLoading: false,
  isSuccessful: false,
};

export const downloadStatement = createAsyncThunk(
  "statement/download",
  async (_, { rejectWithValue }) => {
    try {
      const response = await statementService.statement();
      if (response.status === 200) {
        toast.success(response?.data.message);
      } else {
        toast.error(response?.data?.statusMessage);
      }
      return response.data;
    } catch (error) {
      const err = error as AxiosError<{ message: string }>;
      toast.error(err.response?.data.message);
      return err?.response?.data;
    }
  }
);

export const requestStatement = createAsyncThunk(
  "request/statement",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await statementService.requestStatement(data);
      if (response.status === 200) {
        toast.success(response?.data.statusMessage);
      } else {
        toast.error(response?.data?.statusMessage);
      }
      return response.data;
    } catch (error) {
      const err = error as AxiosError<{ title: string, message: string }>;
      toast.error(err.response?.data.title);
      return err?.response?.data;
    }
  }
);

export const requestThirdPartyStatement = createAsyncThunk(
    "request/thirdPartyStatement",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await statementService.requestThirdPartyStatement(data);
            if (response.status === 200) {
                toast.success(response?.data.statusMessage);
            } else {
                toast.error(response?.data?.title);
            }
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ errors: Array<string>, title: string, message: string }>;
            const errorMsg = err?.response?.data?.title
            console.log({ err, errorMsg })
            toast.error(errorMsg);
            return err?.response?.data;
        }
    }
);


export const statementSlice = createSlice({
  name: "statement",
  initialState,
  reducers: {
    noTract: () => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(downloadStatement.pending, (state, action) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(downloadStatement.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
        };
      })
      .addCase(downloadStatement.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: false,
          //error: action.payload.message,
        };
      })
      .addCase(requestStatement.pending, (state, action) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(requestStatement.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
        };
      })
      .addCase(requestStatement.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: false,
          //error: action.payload.message,
        };
      })
      .addCase(requestThirdPartyStatement.pending, (state, action) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(requestThirdPartyStatement.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
        };
      })
      .addCase(requestThirdPartyStatement.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: false,
          //error: action.payload.message,
        };
      });
  },
});

export default statementSlice.reducer;
